import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-current-point-title',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './current-point-title.component.html',
  styleUrls: ['./current-point-title.component.scss'],
})
export class CurrentPointTitleComponent {
  public currentPointTitle = input<string>();
}
